@import "../../../../new-result-cards/generic-subcomponents/generic-card-title/generic-card-title";
@import "../../../../new-result-cards/generic-subcomponents/generic-card-thumbnail/generic-card-thumbnail";
@import "../../../../../result-page/new-result-cards/public/video-card/subcomponents/video-card-thumbnail/_video-card-thumbnail.scss";

.company__thumbnail {
  margin-right: 0px;
  margin-bottom: 8px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.company__container {
  display: flex;
  flex-direction: column;
  gap: var(--qds-panel-subsection-padding, 16px);
}

.company-item {
  flex: 1 0 50%;
}

.video-widget-thumbnail {
  cursor: pointer;
  min-height: 140px;
  max-height: 140px;
  min-width: 140px;
  max-width: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.result-card__title-link {
  h3 {
    font-size: 18px;
  }
}

.company-item__container {
  a {
    text-decoration: none;
    &:hover {
      .result-card__title-link {
        text-decoration: underline;
      }
    }
  }
}

.dashboard-thumbnail-container {
  inline-size: max-content;
  margin: auto;
}

.dashboard__thumbnail {
  height: 100px;
  margin-bottom: 5px;
  width: 100px;
}

.document__label-panel {
  line-height: 22px;
  font-size: 16px;
  font-weight: 400;
  text-decoration: none;
  color: $svs-se-dark-grey;
  margin-top: 4px;
  @media (min-width: $uiaas-tablet) {
    line-height: 20px;
    font-size: 14px;
  }
}

.document__category {
  color: var(--qds-theme-signature-color-default, #008a16);

  &-accessibility {
    color: #333;
  }
}

.company__container-video {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--qds-panel-subsection-padding, 16px);
}

.video-widget-content {
  display: flex;
  gap: var(--qds-panel-subsection-padding, 16px);
  height: 100%;
}

.video-frame {
  height: 40vh;
  width: 100%;
}
.video-frame_icon {
  position: absolute;
  right: 0;
  top: 0;
  transform: translate(50%, -50%);
}
@media (max-width: 980px) {
  .video-frame {
    width: 50vh;
  }
}
@media (max-width: 650px) {
  .video-frame {
    width: 500px;
  }
}

@media (max-width: 500px) {
  .video-frame {
    width: 350px;
  }
}

.double {
  .company__container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
  .company__container-video {
    flex-direction: row;
    flex-wrap: nowrap;
    .company-item {
      flex: 1 0 49%;
    }
  }
}
